'use client'

import { useEffect, useMemo, useRef } from 'react'
import type { HyperFramesComposition } from './types'
import { buildHyperFramesSrcDoc } from './hyperframes-builders'

type Props = {
  composition: HyperFramesComposition
  timeSec?: number
  playing?: boolean
}

export function HyperFramesIframePreview({
  composition,
  timeSec,
  playing = true,
}: Props) {
  const iframeRef = useRef<HTMLIFrameElement | null>(null)

  const srcDoc = useMemo(() => {
    return buildHyperFramesSrcDoc(composition, {
      controlled: typeof timeSec === 'number',
    })
  }, [composition])

  useEffect(() => {
    if (typeof timeSec !== 'number') return

    const frame = iframeRef.current
    if (!frame?.contentWindow) return

    frame.contentWindow.postMessage(
      {
        type: 'HYPERFRAMES_SEEK',
        timeSec,
        playing,
      },
      '*'
    )
  }, [timeSec, playing])

  if (!srcDoc) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-primary/5 p-8 text-center">
        <div>
          <div className="text-sm font-semibold text-foreground">
            Composición vacía
          </div>
          <div className="mt-1 text-xs text-muted-foreground">
            HyperFrames no devolvió HTML, CSS o JavaScript válido.
          </div>
        </div>
      </div>
    )
  }

  return (
    <iframe
      ref={iframeRef}
      title="HyperFrames preview"
      srcDoc={srcDoc}
      className="h-full w-full border-0 bg-transparent"
      style={{ background: 'transparent' }}
      sandbox="allow-scripts allow-same-origin"
    />
  )
}